import { useQuery } from "@tanstack/react-query";
import { fetchDashboardCampaigns } from "@/api/dashboard";

export function useDashboardCampaigns() {
  return useQuery({
    queryKey: ["dashboard", "campaigns"],
    queryFn: fetchDashboardCampaigns,
    // Campaign state changes over time — refetch on every navigation into the dashboard.
    refetchOnMount: "always",
  });
}
